<div class="title-description">
  {{ details?.description }}
</div>

<app-infobox-table [data]="computeInfoboxEntries()!"></app-infobox-table>
